<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <profildialog ref="profildialog"></profildialog>
    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingdialog"
    ></loadingcomp>
    <kisiadresara
      v-model="adresDialogData"
      v-bind:value="Vize.kisi"
    ></kisiadresara>
    <sirketkisiara
      v-model="vizeAdresDialogData"
      v-if="vizeAdresDialogData.dialogShow"
    ></sirketkisiara>
    <toplukisiekle
      ref="cokluKisiEkle"
      @vizeSave="vizeMultipleUserPush()"
      v-model="cokluKisiList"
    >
    </toplukisiekle>
    <kisiekle
      ref="kisiEkle"
      :value="Vize.kisi"
      @afterSave="equatePassengerData($event)"
    >
    </kisiekle>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title v-if="KayitVarmi">{{$t('Update-Visa')}}</v-toolbar-title>
              <v-toolbar-title v-if="islemTipi != 'get' && KayitVarmi == false">
                {{ $t("Add-v2", { value: $t("Visa") }) }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <v-btn
                  :disabled="!sayfayetki.Update"
                  v-if="KayitVarmi"
                  slot="activator"
                  class="white--text"
                  @click="vizePush()"
                  flat
                >
                  <span class="hidden-sm-and-down">{{ $t("Update") }}</span>
                  <v-icon right dark>system_update_alt</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{
                  $t("Limited-Authorization")
                }}</span>
                <span v-if="sayfayetki.Update">{{ $t("Update") }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  :disabled="!sayfayetki.Save"
                  v-if="islemTipi != 'get' && KayitVarmi == false"
                  slot="activator"
                  class="white--text"
                  @click="vizePush()"
                  flat
                >
                  <span class="hidden-sm-and-down">{{
                    $t("save_button")
                  }}</span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{
                  $t("Limited-Authorization")
                }}</span>
                <span v-if="sayfayetki.Save">{{ $t("Add") }}</span>
              </v-tooltip>
            </v-toolbar>
          </v-flex>
          <v-form ref="formVize" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <!-- v-if="Vize.takipNo.length > 0" -->
                <v-card>
                  <v-list two-line>
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 xl3>
                        <v-layout align-center justify-start row fill-height>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout row align-start wrap justify-start>
                                  <v-flex xs12 sm12 md12>
                                    <div
                                      class="
                                        font-weight-bold
                                        grey--text
                                        subheading
                                      "
                                    >
                                      <v-chip
                                        small
                                        color="orange darken-4"
                                        text-color="white"
                                      >
                                        {{ $t("Tracking-No") }} :
                                        {{ Vize.takipNo }}</v-chip
                                      >
                                    </div>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <div
                                      class="
                                        font-weight-bold
                                        grey--text
                                        subheading
                                      "
                                    >
                                      <v-btn
                                        small
                                        @click="faturala()"
                                        outline
                                        round
                                        color="indigo"
                                        class="text--white"
                                        ><v-icon left>receipt</v-icon
                                        >{{ $t("Invoice") }}</v-btn
                                      >
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>

                      <v-flex xs1 sm1 md1 xl2>
                        <v-card flat="">
                          <v-list-tile> </v-list-tile>
                        </v-card>
                      </v-flex>

                      <v-flex xs7 sm4 md5 xl5>
                        <v-layout align-center justify-start row fill-height>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout row align-start wrap justify-start>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    pt-4
                                    v-if="
                                      Vize.Konsolosluk.KalemDetay.DeadLine !=
                                      null
                                    "
                                  >
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          @click.native="
                                            dialogPasaportDurum = true
                                          "
                                          v-if="
                                            Vize.Konsolosluk.KalemDetay
                                              .DeadLine == 0
                                          "
                                          icon
                                          flat
                                        >
                                          <v-icon
                                            color="green"
                                            dark
                                            v-on="on"
                                            hide-details
                                          >
                                            check_circle_outline
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span
                                        v-if="
                                          Vize.Konsolosluk.KalemDetay
                                            .DeadLine == 0
                                        "
                                      >
                                        {{ $t("Delivered") }}
                                      </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          @click.native="
                                            dialogPasaportDurum = true
                                          "
                                          v-if="
                                            Vize.Konsolosluk.KalemDetay
                                              .DeadLine == 1
                                          "
                                          icon
                                          flat
                                        >
                                          <v-icon
                                            color="primary"
                                            dark
                                            v-on="on"
                                            hide-details
                                          >
                                            autorenew
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span
                                        v-if="
                                          Vize.Konsolosluk.KalemDetay
                                            .DeadLine == 1
                                        "
                                      >
                                        Kasada / Hazırlık
                                      </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          @click.native="
                                            dialogPasaportDurum = true
                                          "
                                          v-if="
                                            Vize.Konsolosluk.KalemDetay
                                              .DeadLine == 2
                                          "
                                          icon
                                          flat
                                        >
                                          <v-icon
                                            color="orange"
                                            dark
                                            v-on="on"
                                            hide-details
                                          >
                                            home_work
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span
                                        v-if="
                                          Vize.Konsolosluk.KalemDetay
                                            .DeadLine == 2
                                        "
                                      >
                                        {{ $t("At-Consulate") }}
                                      </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          @click.native="
                                            dialogPasaportDurum = true
                                          "
                                          v-if="
                                            Vize.Konsolosluk.KalemDetay
                                              .DeadLine == 3
                                          "
                                          icon
                                          flat
                                        >
                                          <v-icon
                                            color="green"
                                            dark
                                            v-on="on"
                                            hide-details
                                          >
                                            verified
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span
                                        v-if="
                                          Vize.Konsolosluk.KalemDetay
                                            .DeadLine == 3
                                        "
                                      >
                                        Kasada / İşlem Tamam
                                      </span>
                                    </v-tooltip>
                                    Pasaport Durum
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <v-layout
                                      align-center
                                      justify-start
                                      row
                                      fill-height
                                    >
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout
                                              row
                                              align-start
                                              wrap
                                              justify-start
                                            >
                                              <div
                                                class="font-weight subheading"
                                              >
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <v-icon
                                                      color="primary"
                                                      dark
                                                      v-on="on"
                                                      v-if="
                                                        Vize.Konsolosluk
                                                          .KalemDetay
                                                          .VizeDurumu == 0
                                                      "
                                                      hide-details
                                                    >
                                                      check_circle_outline
                                                    </v-icon>
                                                  </template>
                                                  <span
                                                    v-if="
                                                      Vize.Konsolosluk
                                                        .KalemDetay
                                                        .VizeDurumu == 0
                                                    "
                                                  >
                                                    {{ $t("Visa-Received") }}
                                                  </span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <v-icon
                                                      color="primary"
                                                      dark
                                                      v-on="on"
                                                      v-if="
                                                        Vize.Konsolosluk
                                                          .KalemDetay
                                                          .VizeDurumu == 1
                                                      "
                                                      hide-details
                                                    >
                                                      autorenew
                                                    </v-icon>
                                                  </template>
                                                  <span
                                                    v-if="
                                                      Vize.Konsolosluk
                                                        .KalemDetay
                                                        .VizeDurumu == 1
                                                    "
                                                  >
                                                    {{ $t("At-Process") }}
                                                  </span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <v-icon
                                                      color="orange"
                                                      dark
                                                      v-on="on"
                                                      v-if="
                                                        Vize.Konsolosluk
                                                          .KalemDetay
                                                          .VizeDurumu == 2
                                                      "
                                                      hide-details
                                                    >
                                                      restore_page
                                                    </v-icon>
                                                  </template>
                                                  <span
                                                    v-if="
                                                      Vize.Konsolosluk
                                                        .KalemDetay
                                                        .VizeDurumu == 2
                                                    "
                                                  >
                                                    {{ $t("Missing-Document") }}
                                                  </span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <v-icon
                                                      color="red"
                                                      dark
                                                      v-on="on"
                                                      v-if="
                                                        Vize.Konsolosluk
                                                          .KalemDetay
                                                          .VizeDurumu == 3
                                                      "
                                                      hide-details
                                                    >
                                                      cancel
                                                    </v-icon>
                                                  </template>
                                                  <span
                                                    v-if="
                                                      Vize.Konsolosluk
                                                        .KalemDetay
                                                        .VizeDurumu == 3
                                                    "
                                                    >Red İade</span
                                                  >
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                  <template
                                                    v-slot:activator="{ on }"
                                                  >
                                                    <v-icon
                                                      color="green"
                                                      dark
                                                      v-on="on"
                                                      v-if="
                                                        Vize.Konsolosluk
                                                          .KalemDetay
                                                          .VizeDurumu == 4
                                                      "
                                                      hide-details
                                                    >
                                                      verified
                                                    </v-icon>
                                                  </template>
                                                  <span
                                                    v-if="
                                                      Vize.Konsolosluk
                                                        .KalemDetay
                                                        .VizeDurumu == 4
                                                    "
                                                  >
                                                    {{ $t("At-Office") }}
                                                  </span>
                                                </v-tooltip>
                                                &nbsp;&nbsp;&nbsp;{{$t("Visa-Condition")}}
                                              </div>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm4 md3 xl2>
                        <v-layout align-center justify-start row fill-height>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout row wrap justify-left="">
                                  <v-flex xs12 sm12 md12>
                                    <v-layout justify-left="">
                                      <div
                                        class="
                                          font-weight-
                                          grey--text
                                          subheading
                                        "
                                      >
                                        {{ $t("Total-Sales") }}:
                                      </div>
                                      <v-layout justify-end>
                                        <div
                                          class="
                                            font-weight-
                                            grey--text
                                            subheading
                                          "
                                        >
                                          {{ totalSalesPrice | priceFormat }}
                                          {{ getparabirimi() }}
                                        </div>
                                      </v-layout>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex pt-1 xs12 sm12 md12>
                                    <v-layout
                                      align-start
                                      fill-height
                                      justify-left=""
                                    >
                                      <div
                                        class="
                                          font-weight-
                                          grey--text
                                          subheading
                                        "
                                      >
                                        {{ $t("Total-Expenses") }} :
                                      </div>
                                      <v-layout justify-end>
                                        <div
                                          class="
                                            font-weight-
                                            grey--text
                                            subheading
                                          "
                                        >
                                          {{ totalCostPrice | priceFormat }}
                                          {{ getparabirimi() }}
                                        </div>
                                      </v-layout>
                                     
                                    </v-layout>
                                  </v-flex>

                                  <!-- <v-flex pt-1 xs12 sm12 md12>
                                    <v-layout
                                      align-start
                                      fill-height
                                      justify-left=""
                                    >
                                      <div
                                        class="
                                          font-weight-
                                          grey--text
                                          subheading
                                        "
                                      >
                                        {{ $t("Profit") }} :
                                      </div>
                                      <v-layout justify-end>
                                        <div
                                          class="
                                            font-weight-
                                            grey--text
                                            subheading
                                          "
                                        >
                                          {{ profit | priceFormat }}
                                          {{ getparabirimi() }}
                                        </div>
                                      </v-layout>
                                     
                                    </v-layout>
                                  </v-flex> -->
                                </v-layout>
                                <v-spacer></v-spacer>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-list>
                </v-card>
              </v-flex>

              <v-flex xs12 md12 sm12>
                <v-tabs
                  style="width: 100%; height: 100%"
                  dark=""
                  v-model="active"
                  color="info"
                  slot="extension"
                  slider-
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#0">
                    {{ $t("tab_general") }}
                  </v-tab>
                  <v-tab href="#1" @click="TabActive('1')">
                    {{ $t("Price-Details-v3") }}
                  </v-tab>
                  <v-tab
                    href="#2"
                    v-if="islemTipi == 'get'"
                    @click="TabActive('2')"
                  >
                    {{ $t("Payments") }}
                  </v-tab>
                  <!-- <v-tab href="#3" @click="TabActive('3')"> 
                    {{ $t("Notes") }}
                  </v-tab>-->
                  <v-tab-item :id="'0'">
                    <v-container fluid grid-list-md>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihim
                                :etiket="$t('Registration-Date')"
                                v-model="Vize.kayitTarihi"
                                v-bind:value="Vize.kayitTarihi"
                                @input="vizeTarihChange()"
                                :rules="[
                                  (v) => !!v || $t('Please-select-a-date'),
                                ]"
                                v-bind:defaultvalue="'ok'"
                              ></tarihim>
                            </v-flex>
                            <v-flex xs12 sm4 pt-2 md2>
                              <genelarama
                                apiname="KullaniciAra"
                                :label="$t('Visa-Officer')" 
                                v-model="Vize.vizeSorumlusu"
                              ></genelarama>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 d-flex>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md6>
                              <v-card light style="min-height: 335px">
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">
                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                            {{ $t("Current-Details") }}
                                            <v-icon right>search</v-icon>
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  <caricomp
                                    v-bind:autofocuss="true"
                                    v-bind:aktifmi="faturaValue"
                                    :Coper="true"
                                    v-bind:statecariyedek="statecari"
                                    v-bind:zorunlumu="true"
                                    v-model="Vize.cariKod.kod"
                                  >
                                  </caricomp>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-card light style="min-height: 335px">
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">
                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                           {{$t('Consular-Information')}}
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn
                                          icon
                                          color="error"
                                          @click.native="
                                            vizeSaticiDialog = true
                                          "
                                        >
                                          <v-icon>sell</v-icon>
                                        </v-btn> -->
                                        <v-btn
                                          icon
                                          color="error"
                                          @click.native="dialogFiyatBul = true"
                                        >
                                          <v-icon>price_change</v-icon>
                                        </v-btn>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  
                                  <konsoloslukara
                                    v-bind:autofocuss="true"
                                    :Coper="true"
                                    v-bind:aktifmi="konsDisabledValue"
                                    v-bind:stateKonsoloslukYedek="
                                      stateKonsolosluk
                                    "
                                    :rules="true"
                                    v-model="Vize.Konsolosluk.satici.kod"
                                  >
                                  </konsoloslukara>
                                  <br>
                                  <v-textarea
          class="mx-1"
          label="Açıklama"
          rows="1"
          v-model="Vize.Konsolosluk.aciklama"
        ></v-textarea>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 d-flex>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md6>
                              <v-card light style="min-height: 575px">
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">


                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                            {{ $t("Passenger-Details") }}
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>

                                        <v-tooltip bottom>
                                          <v-btn
                                            @click="getSablon()"
                                            round
                                            color="error"
                                            :disabled="faturaValue"
                                            icon
                                            slot="activator"
                                          >
                                            <v-icon> switch_account </v-icon>
                                          </v-btn>
                                          <span>{{$t('Select-Template')}}</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                          <v-btn
                                            round
                                            @click="topluKisiAra()"
                                            color="error"
                                            :disabled="faturaValue"
                                            v-if="islemTipi != 'get'"
                                            icon
                                            slot="activator"
                                          >
                                            <v-icon> people </v-icon>
                                          </v-btn>
                                          <span>{{$t('Add-People-in-Bulk')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                          <v-btn
                                            @click="kisiAra()"
                                            round
                                            color="error"
                                            :disabled="faturaValue"
                                            icon
                                            slot="activator"
                                          >
                                            <v-icon> person_search </v-icon>
                                          </v-btn>
                                          <span>{{ $t("Search-Person") }}</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                          <v-btn
                                            @click="kisiDialogOpen()"
                                            round
                                            color="error"
                                            :disabled="faturaValue"
                                            v-if="islemTipi != 'get'"
                                            icon
                                            slot="activator"
                                          >
                                            <v-icon> person_add </v-icon>
                                          </v-btn>
                                          <span>{{$t('Add-People')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                          <v-btn
                                            @click="kisiDialogLoadOpen()"
                                            round
                                            color="error"
                                            v-if="islemTipi != 'yeni'"
                                            :disabled="faturaValue"
                                            icon
                                            slot="activator"
                                          >
                                            <v-icon> manage_accounts </v-icon>
                                          </v-btn>
                                          <span>{{$t('Contact-Settings')}}</span>
                                        </v-tooltip>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                      <v-text-field
                                        tabindex="1"
                                        :disabled="faturaValue"
                                        :label="$t('Name_label')"
                                        v-model="Vize.kisi.firstName"
                                        :rules="NameRules"
                                      ></v-text-field>
                                      <v-text-field
                                        tabindex="3"
                                        :disabled="faturaValue"
                                        :label="$t('Identitynumber_label')"
                                        v-model="Vize.kisi.tcKimlikNo"
                                      ></v-text-field>
                                      <tarihim
                                        tabindex="4"
                                        v-bind:aktifmi="faturaValue"
                                        :etiket="$t('Date-of-Birth')"
                                        v-model="Vize.kisi.dogumTarihi"
                                        v-bind:value="Vize.kisi.dogumTarihi"
                                        :detaygizle="false"
                                        v-bind:defaultvalue="'no'"
                                      ></tarihim>
                                      <v-text-field
                                        tabindex="5"
                                        :disabled="faturaValue"
                                        label="GSM"
                                        v-model="Vize.kisi.telefon1"
                                      ></v-text-field>
                                      <v-text-field
                                        tabindex="6"
                                        :disabled="faturaValue"
                                        :label="$t('Email_label')"
                                        v-model="Vize.kisi.eMail"
                                      ></v-text-field>
                                      <v-text-field
                                        tabindex="7"
                                        :disabled="faturaValue"
                                        :label="$t('Nationality')"
                                        v-model="Vize.ulke"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                      <v-text-field
                                        tabindex="2"
                                        :disabled="faturaValue"
                                        :label="$t('Surname_label')"
                                        v-model="Vize.kisi.lastName"
                                        :rules="NameRules"
                                      ></v-text-field>
                                      <v-select
                                        hide-details
                                        :items="itemsPasaportTip"
                                        v-model="
                                          Vize.Konsolosluk.KalemDetay
                                            .PasaportTip
                                        "
                                        item-text="text"
                                        item-value="value"
                                        label="Pasaport Tip"
                                      ></v-select>
                                      <v-text-field
                                        style="margin-top: 25px"
                                        :label="$t('Passport-No')"
                                        v-model="
                                          Vize.Konsolosluk.KalemDetay.PasaportNo
                                        "
                                        
                                      ></v-text-field>
                                      <v-text-field
                                        :label="$t('Place-Issue')"
                                        v-model="
                                          Vize.Konsolosluk.KalemDetay
                                            .VerildigiYer
                                        "
                                      ></v-text-field>
                                      <tarihim
                                        :etiket="$t('Date-Issue')"
                                        v-model="
                                          Vize.Konsolosluk.KalemDetay
                                            .VerilisTarihi
                                        "
                                        v-bind:value="
                                          Vize.Konsolosluk.KalemDetay
                                            .VerilisTarihi
                                        "
                                        :detaygizle="false"
                                        v-bind:defaultvalue="'no'"
                                      ></tarihim>
                                      <tarihim
                                        :etiket="$t('Finishing-Date')"
                                        v-model="
                                          Vize.Konsolosluk.KalemDetay
                                            .BitisTarihi
                                        "
                                        :detaygizle="false"
                                        v-bind:value="
                                          Vize.Konsolosluk.KalemDetay
                                            .BitisTarihi
                                        "
                                        
                                        v-bind:defaultvalue="'no'"
                                      ></tarihim>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-card light height="100%">
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">
                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                           {{$t('Visa-Information')}}
                                            <v-icon right>search</v-icon>
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 xl6>
                                      <v-layout row wrap>
                                        <v-flex xs12 sm12 md6>
                                          <v-select
                                            hide-details
                                            :items="itemsVizeDurum"
                                            item-text="text"
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .VizeDurumu
                                            "
                                            item-value="value"
                                            :label="$t('Visa-Condition')"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md6>
                                          <v-text-field
                                            hide-details
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay.VizeNo
                                            "
                                            :label="$t('Visa-No')"
                                          ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                          <v-select
                                            style="margin-top: 18px"
                                            hide-details
                                            :items="itemsVizeTip"
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay.Tip
                                            "
                                            item-text="text"
                                            item-value="value"
                                            :label="$t('Visa-Type')"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                          <v-select
                                            style="margin-top: 18px"
                                            hide-details
                                            :items="itemsVizeGiris"
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .GirisTipi
                                            "
                                            item-text="text"
                                            item-value="value"
                                            :label="$t('Input-Type')"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                          <vizecesidi
                                            :label="$t('Visa-Type-v2')"
                                            :getcode="Vize.cariKod.kod"
                                            :getkk="
                                              Vize.Konsolosluk.KalemDetay.Tip
                                            "
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .VizeCesidi
                                            "
                                          >
                                          </vizecesidi>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 xl6>
                                      <v-layout
                                        row
                                        wrap
                                        style="max-height: 70px"
                                        align-center
                                        justify-center
                                        fill-height
                                      >
                                        <v-flex xs5 sm5 md5>
                                          <tarihim
                                            :etiket="
                                              $t('Requested-Visa-Starting-Date')
                                            "
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .IstenenDonem1
                                            "
                                            v-bind:value="
                                              Vize.Konsolosluk.KalemDetay
                                                .IstenenDonem1
                                            "
                                            :rules="[
                                              (v) =>
                                                !!v ||
                                                $t('Please-select-a-date'),
                                            ]"
                                            :detaygizle="false"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs1 sm1 md1 mr-2>
                                          <v-icon>remove</v-icon>
                                        </v-flex>
                                        <v-flex xs5 sm5 md5>
                                          <tarihim
                                            :etiket="
                                              $t('Requested-Visa-Expiry-Date')
                                            "
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .IstenenDonem2
                                            "
                                            v-bind:value="
                                              Vize.Konsolosluk.KalemDetay
                                                .IstenenDonem2
                                            "
                                            :rules="[
                                              (v) =>
                                                !!v ||
                                                $t('Please-select-a-date'),
                                            ]"
                                            :detaygizle="false"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout
                                        row
                                        wrap
                                        style="max-height: 70px"
                                        align-center
                                        justify-center
                                        fill-height
                                      >
                                        <v-flex xs5 sm5 md5 xl5>
                                          <tarihim
                                            :etiket="
                                              $t('Actual-Visa-Starting-Date')
                                            "
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .KonsVerilisTarihi
                                            "
                                            v-bind:value="
                                              Vize.Konsolosluk.KalemDetay
                                                .KonsVerilisTarihi
                                            "
                                            :detaygizle="false"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs1 sm1 md1 xl1 mr-2>
                                          <v-icon>remove</v-icon>
                                        </v-flex>
                                        <v-flex xs5 sm5 md5 xl5>
                                          <tarihim
                                            :etiket="
                                              $t('Actual-Visa-Expiry-Date')
                                            "
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .KonsCikisTarihi
                                            "
                                            v-bind:value="
                                              Vize.Konsolosluk.KalemDetay
                                                .KonsCikisTarihi
                                            "
                                            :detaygizle="false"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                      </v-layout>
                                      <v-layout
                                        row
                                        wrap
                                        style="max-height: 50px"
                                        align-center
                                        justify-center
                                        fill-height
                                      >
                                        <v-flex xs5 sm5 md5>
                                          <tarihim
                                            :etiket="$t('Meeting-Date')"
                                            :detaygizle="false"
                                            v-model="
                                              Vize.Konsolosluk.KalemDetay
                                                .RandevuZamani
                                            "
                                            v-bind:value="
                                              Vize.Konsolosluk.KalemDetay
                                                .RandevuZamani
                                            "
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs1 sm1 md1 mr-2>
                                          <v-icon>remove</v-icon>
                                        </v-flex>
                                        <v-flex xs5 sm5 md5>
                                          <v-text-field
                                            :label="$t('Meeting-Time-v2')"
                                            v-model="RandevuZamaniSaat"
                                            type="time"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 d-flex>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md6>
                              <v-card
                                light
                                style="min-height: 340px"
                                height="100%"
                              >
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">
                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                            {{ $t("Policy-Details") }}
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 xl6>
                                      <sigortaara
                                        v-bind:autofocuss="true"
                                        v-bind:aktifmi="sigortaDisabledValue"
                                        :Coper="true"
                                        v-bind:stateSigortaYedek="stateSigorta"
                                        v-model="Vize.Sigorta.satici.kod"
                                      >
                                      </sigortaara>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 xl6>
                                      <v-flex xs12 sm12 md12>
                                        <v-text-field
                                          :label="$t('Policy-No')"
                                          height="30"
                                          v-model="
                                            Vize.Sigorta.KalemDetay.PoliceNo
                                          "
                                        ></v-text-field>
                                      </v-flex>
                                      <v-layout row wrap>
                                        <v-flex xs12 sm12 md6 xl6>
                                          <tarihim
                                            :etiket="$t('Starting-Date')"
                                            :detaygizle="false"
                                            v-model="Vize.Sigorta.donem1"
                                            v-bind:value="Vize.Sigorta.donem1"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs12 sm12 md6 xl6>
                                          <tarihim
                                            :etiket="$t('Finishing-Date')"
                                            :detaygizle="false"
                                            v-model="Vize.Sigorta.donem2"
                                            v-bind:value="Vize.Sigorta.donem2"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 xl6>
                                          <tarihim
                                            :etiket="$t('Date-of-Issue')"
                                            v-model="
                                              Vize.Sigorta.KalemDetay
                                                .PoliceTarihi
                                            "
                                            v-bind:value="
                                              Vize.Sigorta.KalemDetay
                                                .PoliceTarihi
                                            "
                                            :detaygizle="false"
                                            v-bind:defaultvalue="'no'"
                                          ></tarihim>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-card light style="min-height: 340px">
                                <v-card-title primary title>
                                  <v-flex xs12 sm12 pt-2 md12>
                                    <v-layout row wrap class="project overdue">
                                      <v-toolbar
                                        flat=""
                                        size="120px"
                                        dark
                                        color="white"
                                      >
                                        <v-toolbar-title>
                                          <span
                                            class="
                                              headline
                                              black--text
                                              font-weight-bold
                                            "
                                          >
                                            {{ $t("Other-Details")
                                            }}<v-icon right>search</v-icon>
                                          </span>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                      </v-toolbar>
                                    </v-layout>
                                  </v-flex>
                                </v-card-title>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                      <v-text-field
                                        :label="$t('Counter-Booking-Code')"
                                        v-model="Vize.karsiRezKod"
                                      ></v-text-field>
                                      <geneltipara
                                        tip="AcenteDepartman"
                                        v-model="Vize.acenteDepartman"
                                      ></geneltipara>
                                      <v-flex mt-3>
                                        <genelarama
                                          apiname="MasrafMerkeziAra"
                                          :label="
                                            $t('Expense-Center-v2') + ' : '
                                          "
                                          v-model="Vize.masrafMerkezi"
                                        ></genelarama>
                                      </v-flex>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                      <v-text-field
                                        :label="$t('Person-Offering-Booking')"
                                        v-model="Vize.rezVeren"
                                      ></v-text-field>
                                      <v-text-field
                                        label="Pozis. No"
                                        v-model="Vize.pozisyonNo"
                                      ></v-text-field>
                                      <v-text-field
                                        :label="$t('Division-No')"
                                        v-model="Vize.hizmetNo"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item :id="'1'">
                    <v-layout v-if="fiyatBilgiTab" row wrap>
                      <v-flex xs12 sm12 md12 d-flex>
                        <v-layout row wrap>
                          <!-- Fiyat Bilgileri -- Konsolosluk Başlıyor --  -->
                          <v-flex xs12 sm12 md12>
                            <v-card light style="max-height: 350px">
                              <v-card-text>
                                <v-flex
                                  v-show="
                                    $vuetify.breakpoint.md ||
                                    $vuetify.breakpoint.lg ||
                                    $vuetify.breakpoint.xl
                                  "
                                >
                                  <v-card>
                                    <v-layout row wrap align-center pl-3>
                                      <v-flex xs12 sm12 md1> </v-flex>
                                      <v-flex xs12 sm12 md1>
                                        <v-list>
                                          <v-list-tile>
                                            <strong>Pnr No</strong>
                                          </v-list-tile>
                                        </v-list>
                                      </v-flex>

                                      <v-flex xs12 sm12 md2>
                                        <v-layout row wrap>
                                          <v-list>
                                            <v-list-tile>
                                              <strong>{{$t('Seller-Code')}}</strong>
                                            </v-list-tile>
                                          </v-list>
                                        </v-layout>
                                      </v-flex>

                                      <v-flex xs12 sm12 md2>
                                        <v-layout row wrap>
                                          <v-list>
                                            <v-list-tile>
                                              <span
                                                class="
                                                  subheading
                                                  red--text
                                                  font-weight-bold
                                                "
                                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                                              >
                                              <span class="ml-3">
                                                <strong>{{
                                                  $t("Priceice")
                                                }}</strong>
                                              </span>
                                            </v-list-tile>
                                          </v-list>
                                        </v-layout>
                                      </v-flex>

                                      <v-flex xs12 sm12 md2>
                                        <v-layout row wrap>
                                          <v-list>
                                            <v-list-tile>
                                              <strong>{{
                                                $t("Currency-Unit")
                                              }}</strong>
                                            </v-list-tile>
                                          </v-list>
                                        </v-layout>
                                      </v-flex>
                                      <v-flex xs12 sm12 md1>
                                        <v-layout row wrap>
                                          <v-list>
                                            <v-list-tile>
                                              <strong>{{$t('Currency')}}</strong>
                                            </v-list-tile>
                                          </v-list>
                                        </v-layout>
                                      </v-flex>

                                      <v-flex xs12 sm12 md2>
                                        <v-layout row wrap>
                                          <v-list>
                                            <v-list-tile>
                                              <strong>{{ $t('Invoice-Number') }}</strong>
                                            </v-list-tile>
                                          </v-list>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 1)"
                              @kurAlisHesapla="changeCostPrice($event, 1)"
                              v-bind:value="Vize.Konsolosluk"
                              v-model="Vize.Konsolosluk"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:takipNo="Number(Vize.takipNo)"
                              v-bind:kalemAdi="'Konsolosluk'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 2)"
                              @kurAlisHesapla="changeCostPrice($event, 2)"
                              v-bind:value="Vize.Sigorta"
                              v-model="Vize.Sigorta"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'Sigorta'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 3)"
                              @kurAlisHesapla="changeCostPrice($event, 3)"
                              v-bind:value="Vize.Hizmet"
                              v-model="Vize.Hizmet"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'Hizmet'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 4)"
                              @kurAlisHesapla="changeCostPrice($event, 4)"
                              v-bind:value="Vize.Diger"
                              v-model="Vize.Diger"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'Diğer'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 5)"
                              @kurAlisHesapla="changeCostPrice($event, 5)"
                              v-bind:value="Vize.EkHizmet1"
                              v-model="Vize.EkHizmet1"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet1'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 6)"
                              @kurAlisHesapla="changeCostPrice($event, 6)"
                              v-bind:value="Vize.EkHizmet2"
                              v-model="Vize.EkHizmet2"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet2'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 7)"
                              @kurAlisHesapla="changeCostPrice($event, 7)"
                              v-bind:value="Vize.EkHizmet3"
                              v-model="Vize.EkHizmet3"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet3'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 8)"
                              @kurAlisHesapla="changeCostPrice($event, 8)"
                              v-bind:value="Vize.EkHizmet4"
                              v-model="Vize.EkHizmet4"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet4'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 9)"
                              @kurAlisHesapla="changeCostPrice($event, 9)"
                              v-bind:value="Vize.EkHizmet5"
                              v-model="Vize.EkHizmet5"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet5'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 10)"
                              @kurAlisHesapla="changeCostPrice($event, 10)"
                              v-bind:value="Vize.EkHizmet6"
                              v-model="Vize.EkHizmet6"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet6'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <fiyatbilgileri
                              @kurSatisHesapla="changeSalesPrice($event, 11)"
                              @kurAlisHesapla="changeCostPrice($event, 11)"
                              v-bind:value="Vize.EkHizmet7"
                              v-model="Vize.EkHizmet7"
                              v-bind:kayitTarihi="vizeKayitTarihi"
                              v-bind:kalemAdi="'EkHizmet7'"
                              v-bind:dovizList="doviztipi"
                            ></fiyatbilgileri>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item :id="'2'" v-if="islemTipi == 'get'">
                    <v-layout v-if="odemelerTab" row wrap>
                      <v-flex xs12 sm12 md12 d-flex>
                        <odemetab
                          v-model="Tahsilat"
                          :takipNo="Vize.takipNo"
                        ></odemetab>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item :id="'3'">
                    <v-textarea :label="$t('Notes')" tabindex="39"  hide-details=""></v-textarea>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
            </v-layout>
          </v-form>
        </v-layout>
      </v-card>

      <v-dialog v-model="dialogPasaportDurum" persistent max-width="400px">
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Pasaport Durumu</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-radio-group v-model="Vize.Konsolosluk.KalemDetay.DeadLine">
                  <v-radio :label="$t('Delivered')" :value="0"></v-radio>
                  <v-radio
                    :label="$t('At-Register-Preparation')"
                    :value="1"
                  ></v-radio>
                  <v-radio :label="$t('At-Consulate')" :value="2"></v-radio>
                  <v-radio
                    :label="$t('At-Register-Process-Completed')"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="dialogPasaportDurum = false"
              >{{ $t("cancel_button") }}</v-btn
            >
            <v-btn color="blue darken-1" flat @click="vizePush()">{{
              $t("save_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogFiyatBul"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogFiyatBul = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title> {{ $t("Find-Price") }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialogFiyatBul = false">{{
                $t("Close")
              }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 md2>
                <konsoloslukminiara
                  v-model="fiyatBulParams.SaticiKodu"
                ></konsoloslukminiara>
              </v-flex>
              <v-flex xs12 sm12 md2>
                <tarihim
                  :etiket="this.$t('Visa-Starting-Date')"
                  v-model="fiyatBulParams.Donem1"
                ></tarihim>
              </v-flex>
              <v-flex xs12 sm12 md2>
                <tarihim
                  :etiket="this.$t('Visa-Expiry-Date')"
                  v-model="fiyatBulParams.Donem2"
                ></tarihim>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-autocomplete
                  :items="itemsVizeGiris"
                  item-text="text"
                  item-value="value"
                  :hide-details="true"
                  :label="this.$t('Input-Type')"
                  v-model="fiyatBulParams.GirisTipi"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-autocomplete
                  :items="itemsVizeTip"
                  item-text="text"
                  item-value="value"
                  :hide-details="true"
                  :label="$t('Visa-Type')"
                  v-model="fiyatBulParams.Tip1"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <vizecesidi
                  :label="$t('Visa-Type-v2')"
                  :getcode="Vize.cariKod.kod"
                  :getkk="fiyatBulParams.Tip1"
                  v-model="fiyatBulParams.VizeCesit"
                >
                </vizecesidi>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <geneltipara
                  v-model="fiyatBulParams.FiyatTipi"
                  tip="VizeFiyatTipi"
                  :label="$t('Price-Type-v2')"
                ></geneltipara>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-btn color="info" fab small dark @click="getFiyatList()">
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap mt-4>
              <v-flex
                v-for="item in cardItems"
                v-bind:key="item.SiraNo"
                pb-3
                xs12
                sm12
                md12
              >
                <v-hover>
                  <v-card
                    width="100%"
                    slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    class="elevation-1 pa-3"
                  >
                    <v-layout row wrap align-center justify-end>
                      <v-flex xs12 sm6 md3>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            class="font-weight-medium grey--text caption"
                          >
                            <v-icon color="#67768f" small
                              >fiber_manual_record</v-icon
                            >
                            {{ item.Tip1 }}
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            class="font-weight-bold grey--text caption"
                          >
                            <v-icon color="#67768f" small>payment</v-icon>
                            {{ item.SaticiKodu }}
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">{{this.$t('Visa-Starting-Date')}} :</span
                          >{{ item.Donem1 | dateformat }}</v-flex
                        >
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">{{this.$t('Visa-Expiry-Date')}} :</span
                          >{{ item.Donem2 | dateformat }}</v-flex
                        >
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f"
                            >{{ $t("Price-Type-v2") }} :</span
                          >{{ item.FiyatTipi.isim }}</v-flex
                        >
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                        >
                          <span style="color: #67768f">{{ this.$t('Purchase-Price') }} :</span>
                          {{ item.AlisFiyat | moneyformat }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">{{ this.$t('Purchase-Price-Currency') }} :</span
                          >{{ item.AlisPara }}</v-flex
                        >
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">{{this.$t('Exchange-Rate')}} :</span
                          >{{ item.AlisKur }}</v-flex
                        >
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                        >
                          <span style="color: #67768f">{{ this.$t('Sale-Price') }} :</span>
                          {{ item.SatisFiyat | moneyformat }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">
                            {{ $t("Sales-Money") }} :</span
                          >{{ item.SatisPara }}</v-flex
                        >
                        <v-flex
                          xs12
                          sm12
                          md12
                          style="color: #67768f"
                          class="font-weight-medium grey--text caption"
                          ><span style="color: #67768f">
                            {{ $t("Sales-Currency") }} :</span
                          >{{ item.SatisKur }}</v-flex
                        >
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm12
                            md12
                            class="font-weight-medium grey--text pl-2 caption"
                          >
                            <span style="color: #67768f"> {{$t('Visa-Type')}} : </span>
                            {{ item.VizeCesit.isim }}
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            class="font-weight-medium grey--text pl-2 caption"
                          >
                            <span style="color: #67768f"
                              >{{ $t("VAT") }} :</span
                            >
                            {{ item.KDV }}
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            class="font-weight-medium grey--text pl-2 caption"
                          >
                            <span style="color: #67768f"
                              >{{ $t("Description") }} :</span
                            >
                            {{ item.Aciklama }}
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm6 md1>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm12
                            md6
                            class="font-weight-medium grey--text caption"
                          >
                            <v-btn
                              color="info"
                              @click="selectVizeFiyat(item)"
                              outline
                              fab
                              small
                            >
                              <v-icon>done</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-hover>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="vizeSaticiDialog" persistent max-width="900px">
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">{{ $t('Service-Price-Calculation') }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  :label="this.$t('Total-Service-Fee')"
                  v-model="vizeSatisFiyat"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <genelarama
                  apiname="SaticiAra"
                  :tip="10"
                  :label="this.$t('Service-Vendor-Code')"
                  v-model="Vize.Hizmet.satici"
                  @input="saticiKdvAyarla()"
                ></genelarama>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="vizeSaticiDialog = false"
              >{{ $t("Close") }}</v-btn
            >
            <v-btn color="blue darken-1" flat @click="vizeSend()"
              >{{$t('Calculate')}}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import router from '../../../../router';
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import konsoloslukara from "@/components/app/coper/comp/konsoloslukara.vue";
import sigortaara from "@/components/app/coper/comp/sigortaara.vue";
import vize from "@/components/app/coper/vize/vize";
import vizecesidi from "@/components/app/coper/component/vizecesidi.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import fiyatbilgileri from "@/components/app/coper/vize/comp/fiyatbilgileri.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import kisiadresara from "@/components/app/coper/component/kisiadresara.vue";
import sirketkisiara from "@/components/app/customcomp/sirketkisiara";
import saticiortakbilgi from "@/components/app/coper/vize/comp/saticiortakbilgi";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import iptaldialog from "@/components/app/coper/vize/comp/iptaldialog";
import odemetab from "@/components/app/coper/vize/comp/odemetab";
import konsoloslukminiara from "@/components/app/coper/comp/konsoloslukminiara.vue";
import toplukisiekle from "@/components/app/coper/vize/comp/toplukisiekle";
import kisiekle from "@/components/app/coper/comp/kisiekle.vue";
import profildialog from "@/components/app/coper/comp/profildialog.vue";
import { wrapStageHandler } from "echarts/lib/stream/Scheduler";

export default {
  data() {
    return {
      vizeKayitTarihi: null,
      NameRules: [(v) => !!v || this.$t("Mandatory-Areas")],
      cokluKisiList: [],
      cardItems: [],
      fiyatBulParams: {
        CariKod: null,
        SaticiKodu: null,
        Donem1: null,
        Donem2: null,
        Tip1: 0,
        VizeCesit: {
          id: "0",
          kod: null,
          isim: null,
          tip: 0,
          intField: null,
        },
        GirisTipi: -1,
        FiyatTipi: null,
      },
      dialogFiyatBul: false,
      Tahsilat: {
        TakipNo: 0,
        OdemeTarihi: null,
        OdemeTipi: 0,
        NakitBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null,
        },
        KrediKartBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: null,
          PosKodu: null,
          PosTaksit: null,
          PuanTutari: null,
        },
        HavaleBilgi: {
          Banka: null,
          Aciklama: null,
        },
        SanalPosBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null,
        },
        ParaBirimi: "TL",
        Kur: 1,
        EvrakNo: null,
        Aciklama: null,
        PnrTutarListesi: [],
      },
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      totalCostPrice: 0,
      totalSalesPrice: 0,
      profit:0,
      mountKayit:false,
      KayitVarmi: false,
      loadingmesaj: "Vize",
      loadingdialog: false,
      text1: "",
      snackbar: false,
      dialogPasaportDurum: false,
      active: "",
      RandevuZamaniSaat: "",
      carikod: null,
      konsoloslukKod: null,
      sigortaKod: null,
      doviztipi: [],
      statecari: [],
      stateSigorta: [],
      stateKonsolosluk: [],
      valid: false,
      islemTipi: null,
      itemsPasaportTip: [
        {
          text: "Normal",
          value: 0,
        },
        {
          text: this.$t("Green"),
          value: 1,
        },
        {
          text: this.$t("Diplomatic"),
          value: 2,
        },
        {
          text: this.$t("Other"),
          value: 3,
        },
      ],
      fiyatBilgiTab: false,
      odemelerTab: false,
      itemsVizeDurum: vize.VizeDurumu(),
      itemsVizeTip: vize.VizeTipi(),
      itemsVizeGiris: vize.VizeGirisTipi(),
      Rez: vize.Rezervasyon(),
      vizeData: {
        kisi: vize.Adres(),
        takipNo: 0,
        Konsolosluk: Object.assign(
          {},
          vize.KalemBase(),
          vize.KalemKonsolosluk()
        ),
        Sigorta: Object.assign({}, vize.KalemBase(), vize.KalemSigorta()),
        Hizmet: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        Diger: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet1: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet2: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet3: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet4: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet5: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet6: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
        EkHizmet7: Object.assign({}, vize.KalemBase(), vize.KalemDiger()),
      },
      adresDialogData: {
        dialogShow: false,
        adres: vize.Adres(),
      },
      vizeAdresDialogData: {
        dialogShow: false,
        name: null,
      },
      Vize: {},
      konsoloslukSalesPrice: 0,
      konsoloslukCostPrice: 0,
      sigortaSalesPrice: 0,
      sigortaCostPrice: 0,
      hizmetSalesPrice: 0,
      hizmetCostPrice: 0,
      digerSalesPrice: 0,
      digerCostPrice: 0,
      ekhizmet1SalesPrice: 0,
      ekhizmet1CostPrice: 0,
      ekhizmet2SalesPrice: 0,
      ekhizmet2CostPrice: 0,
      ekhizmet3SalesPrice: 0,
      ekhizmet3CostPrice: 0,
      ekhizmet4SalesPrice: 0,
      ekhizmet4CostPrice: 0,
      ekhizmet5SalesPrice: 0,
      ekhizmet5CostPrice: 0,
      ekhizmet6SalesPrice: 0,
      ekhizmet6CostPrice: 0,
      ekhizmet7SalesPrice: 0,
      ekhizmet7CostPrice: 0,
      konsDisabledValue: false,
      sigortaDisabledValue: false,
      faturaValue: false,
      gelenFaturaValue:false,
      el: null,
      firstVizeControl: 0,
      firstSigortaControl: 0,
      cardItemsVizeFiyat: [],
      vizeSatisFiyat: 0,
      vizeFiyatParams: {
        Konsolosluk: null,
        Donem1Bas: null,
        Donem1Bit: null,
        Donem2Bas: null,
        Donem2Bit: null,
      },
      vizeFiyatItem: {},
      vizeSaticiDialog: false,
    };
  },
  beforeMount: beforeMount,
  mounted() {
    //this.el = this.$refs.fab.$el

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      if (this.$route.query.islem == "get") {
        this.KayitVarmi = true;
        this.loadingdialog = true;
        this.loadingmesaj = "Vize";
        this.islemTipi = "get";
        let params = {
          TakipNo: this.$route.query.TakipNo,
        };
        tool.http_post(this, "VizeLoad", params).then(
          (response) => {
            if (response.body.Status == true) {
              if (response.body.ErrorList != null) {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingdialog = false;
              }

              if (response.body.data.masrafMerkezi.id == 0) {
                response.body.data.masrafMerkezi = {
                  id: "",
                  kod: "",
                  isim: "",
                  isimAra: "",
                };
              }
              if (response.body.data.acenteDepartman.id == 0) {
                response.body.data.acenteDepartman = {
                  id: "",
                  kod: null,
                  isim: "",
                  isimAra: "",
                };
              }
              this.Vize = response.body.data;

              // Kalemler boş ise null olarak yaratmak için kontrol
              this.vizeNullCheck();
              //Yolcu Bilgileri Ad Soyad Ayrı yazımı varmı yokmu control ediliyor
              this.checkNameAndSurname(this.Vize.kisi);
              //Search Componentlerin değerleri dolduruluyor
              //cari
              var seciliCariitems = [
                {
                  unvan1: response.body.data.cariKod.isim,
                  id: response.body.data.cariKod.kod,
                },
              ];
              this.statecari = seciliCariitems;

              //sigorta
              var seciliSigortaitems = [
                {
                  name:
                    response.body.data.Sigorta.satici.kod +
                    "-" +
                    response.body.data.Sigorta.satici.isim,
                  value: response.body.data.Sigorta.satici.kod,
                },
              ];

              this.stateSigorta = seciliSigortaitems;

              //konsolosluk
              var seciliKonsoloslukitems = [
                {
                  name:
                    response.body.data.Konsolosluk.satici.kod +
                    "-" +
                    response.body.data.Konsolosluk.satici.isim,
                  value: response.body.data.Konsolosluk.satici.kod,
                },
              ];

              this.stateKonsolosluk = seciliKonsoloslukitems;

              //RandevuZamanı Saat Dolduruluyor
              if (this.Vize.Konsolosluk.KalemDetay.RandevuZamani != null) {
                var Saat =
                  this.Vize.Konsolosluk.KalemDetay.RandevuZamani.substring(
                    11,
                    16
                  );

                if (Saat != "00:00") {
                  this.RandevuZamaniSaat = Saat;
                }
              }
              this.loadingdialog = false;
            } else {
              this.text1 = this.$t(response.body.ErrorList[0]);
              this.snackbar = true;
              this.loadingdialog = false;
            }
          },
          (response) => {
            this.text1 = this.$t(response.body.ExceptionMessage);
            this.snackbar = true;
            this.loadingdialog = false;
          }
        );
        //this.loadingdialog = false
      }

      if (this.$route.query.islem == "yeni") {
        this.active = "0";
        this.islemTipi = "yeni";
        // this.loadingdialog = false
        var credentials = JSON.parse(window.localStorage.getItem("response"));

        var prm = {
          id: credentials.UserId,
          intField: null,
          kod: credentials.UserId + " ",
          isim: credentials.AdSoyad + " ",
          tip: "",
        };
        this.Vize.vizeSorumlusu = prm;
        
      }
      //Fiyat Bilgileri Tab'ı için Kur çekiliyor.
     
      this.kurCek();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  methods: {
    getSablon(){
      this.$refs.profildialog
        .open(this.Vize.kisi.profilId, {
            color: "red"
        })
        .then(profildialog => {
            if (profildialog.ok) {
              this.Vize.kisi.profilId = profildialog.id;
            }
        });
    },
    saticiKdvAyarla() {
      this.Vize.Hizmet.satis.KDVOran = this.Vize.Hizmet.satici.KDV;
    },
    setVizeSatici(val) {
      if (this.$refs.formVize.validate()) {
        this.vizeFiyatItem = val;
        this.vizeSaticiDialog = true;
      } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.');
        this.snackbar = true;
      }
    },
    getVizeFiyat() {
      if (this.$refs.formVize.validate()) {
        var checkVizeFiyatStatus =
          this.vizeSatisFiyat - this.Vize.Konsolosluk.yet_Satis;
        if (checkVizeFiyatStatus > 0) {
          this.vizeSend();
        } else {
          this.text1 =this.$t('Total-Service-Fee-cannot-be-greater-than-the-Consulate-sales-price.');
            
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.');
        this.snackbar = true;
        this.vizeSaticiDialog = true;
        this.loadingvmodel = false;
      }
    },
    getVizeFiyatList() {
      tool.http_post(this, "VizeFiyatList", this.vizeFiyatParams).then(
        (response) => {
          if (response.body.Status == true) {
            this.cardItemsVizeFiyat = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = this.$t('error-occurred-please-try-again');
          this.snackbar = true;
        }
      );
    },
    vizeTarihChange(val) {
      // this.Vize.Konsolosluk.KalemDetay.IstenenDonem1=this.Vize.kayitTarihi;
      // this.Vize.Konsolosluk.KalemDetay.IstenenDonem2=this.Vize.kayitTarihi;
    },
    kisiDialogLoadOpen() {
      this.$refs.kisiEkle.Load(this.Vize.kisi.id);
    },
    equatePassengerData(val) {
      this.Vize.kisi.id = val.Id;
      this.Vize.kisi.adSoyad = val.Ad + " " + val.Soyad;
      this.Vize.kisi.gsm = val.GSM;
      this.Vize.kisi.tcKimlikNo = val.TCKimlikNo;
      this.Vize.kisi.firstName = val.Ad;
      this.Vize.kisi.lastName = val.Soyad;
      this.Vize.kisi.eMail = val.Email;
      this.Vize.kisi.telefon1 = val.Telefon1;
      this.Vize.kisi.cinsiyet = val.Cinsiyet;
      this.Vize.kisi.dogumTarihi = val.DogumTarihi;
      this.Vize.kisi.adres = val.Adres;
      this.Vize.Konsolosluk.KalemDetay.PasaportNo = val.PasaportNo;
      this.Vize.Konsolosluk.KalemDetay.PasaportTip = val.PasaportTip;
      this.Vize.Konsolosluk.KalemDetay.VerildigiYer = val.VerildigiYer;
      this.Vize.Konsolosluk.KalemDetay.VerilisTarihi = val.VerilisTarihi;
      this.Vize.Konsolosluk.KalemDetay.BitisTarihi = val.BitisTarihi;
      this.Vize.kisi.Uyruk = val.Uyruk;
      this.$refs.kisiEkle.close();
    },
    kisiDialogOpen() {
      this.$refs.kisiEkle.open();
    },
    topluKisiAra() {
      this.NameRules = [];
      if (this.$refs.formVize.validate()) {
        this.$refs.cokluKisiEkle.open();
      } else {
        this.text1 = this.$t('Zorunlu Alanlari Doldurunuz');
        this.snackbar = true;
      }
    },
    faturala() {
      var pnrList = [];
      var degerler = [];
      if (this.Vize.Konsolosluk.islemRef != 0) {
        pnrList.push(this.Vize.Konsolosluk.PNR_No);
      }
      if (this.Vize.Hizmet.islemRef != 0) {
        pnrList.push(this.Vize.Hizmet.PNR_No);
      }
      if (this.Vize.Sigorta.islemRef != 0) {
        pnrList.push(this.Vize.Sigorta.PNR_No);
      }
      if (this.Vize.Diger.islemRef != 0) {
        pnrList.push(this.Vize.Diger.PNR_No);
      }
      if (this.Vize.EkHizmet1.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet1.PNR_No);
      }
      if (this.Vize.EkHizmet2.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet2.PNR_No);
      }
      if (this.Vize.EkHizmet3.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet3.PNR_No);
      }
      if (this.Vize.EkHizmet4.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet4.PNR_No);
      }
      if (this.Vize.EkHizmet5.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet5.PNR_No);
      }
      if (this.Vize.EkHizmet6.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet6.PNR_No);
      }
      if (this.Vize.EkHizmet7.islemRef != 0) {
        pnrList.push(this.Vize.EkHizmet7.PNR_No);
      }

      let params = {
        PNR_List: pnrList,
      };
      tool.http_post(this, "VadeTarihiHesapla", params).then(
        (response) => {
          if (response.body.Status == true) {
            response.body.data.forEach((element) => {
              var item = {
                kayit: {
                  PNR_No: element.PNR_No,
                  Kayit_Tarihi: this.Vize.kayitTarihi,
                  Cari_Kod: this.Vize.cariKod.kod,
                  EFatura: this.Vize.cariKod.EfaturaKayitli,
                },
                FaturaTarihi: element.FaturaTarihi,
                VadeTarihi: element.VadeTarihi,
              };
              degerler.push(item);
            });
            window.localStorage.setItem(
              "container_secilifat",
              JSON.stringify(degerler)
            );
            var url = "#/fatura/copertoplufatura";
            window.open(url, "_target");
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    selectVizeFiyat(val) {
      var seciliKonsoloslukitems = [
        {
          name: val.SaticiKodu + "-" + val.SaticiAdi,
          value: val.SaticiKodu,
        },
      ];
      var satici = {
        id: val.SaticiKodu,
        kod: val.SaticiKodu,
        isim: val.SaticiAdi,
        tip: 11,
        YurtIci_YurtDisi: null,
        KDV: 0,
      };
      this.Vize.Konsolosluk.satici = satici;
      this.stateKonsolosluk = seciliKonsoloslukitems;
      this.Vize.Konsolosluk.donem1 = val.Donem1;
      this.Vize.Konsolosluk.donem2 = val.Donem2; 
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem1 = val.Donem1;
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem2 = val.Donem2;
      this.Vize.Konsolosluk.KalemDetay.VizeCesidi = val.VizeCesit;
      this.Vize.Konsolosluk.KalemDetay.GirisTipi = val.GirisTipi;
      this.Vize.Konsolosluk.yet_Satis = val.SatisFiyat;
      this.Vize.Konsolosluk.yet_Alis = val.AlisFiyat;
      this.Vize.Konsolosluk.satisPara.paraBirimi = val.SatisPara;
      this.Vize.Konsolosluk.alisPara.paraBirimi = val.AlisPara;
      this.Vize.Konsolosluk.satisPara.kur = this.kurgetir(val.SatisPara,1);
      this.Vize.Konsolosluk.alisPara.kur = this.kurgetir(val.AlisPara,2);

      this.dialogFiyatBul = false;
    },
    kurgetir(kod,type) {
      var params1 = {
        Tarih: helpers.getDateNow(),
        DovizKod: kod,
      };

        this.$http
          .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
            headers: auth.getAuthCompaniesInfo()
          })
          .then(
            (response) => {
              if (response.body == 0.0) {
                if(type == 1){
                  this.Vize.Konsolosluk.satisPara.kur = 1;
                }else{
                  this.Vize.Konsolosluk.alisPara.kur = 1;
                }
              } else {
               if(type == 1){
                  this.Vize.Konsolosluk.satisPara.kur = response.body;
                }else{
                  this.Vize.Konsolosluk.alisPara.kur = response.body;
                }
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Kur Hesapla";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-Kur Hesapla";
                this.snackbar = true;
              }
            }
          );
      
    },
    getFiyatList() {
      this.cardItems = [];
      this.loadingdialog = true;
      this.fiyatBulParams.CariKod = this.Vize.cariKod.kod;
      tool.http_post(this, "VizeFiyatSec", this.fiyatBulParams).then(
        (response) => {
          if (response.body.Status == true) {
            this.cardItems = response.body.data;
            this.loadingdialog = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
    },
    vizePush: vizePush,
    vizeMultipleUserPush: vizeMultipleUserPush,
    vizeNullCheck: vizeNullCheck,
    kurCek: kurCek,
    getparabirimi() {
      return helpers.getparabirimi();
    },
    changeSalesPrice(val, tip) {
      switch (tip) {
        case 1:
          this.konsoloslukSalesPrice = 0;
          this.konsoloslukSalesPrice = val;
          break;
        case 2:
          this.sigortaSalesPrice = 0;
          this.sigortaSalesPrice = val;
          break;
        case 3:
          this.hizmetSalesPrice = 0;
          this.hizmetSalesPrice = val;
          break;
        case 4:
          this.digerSalesPrice = 0;
          this.digerSalesPrice = val;
          break;
        case 5:
          this.ekhizmet1SalesPrice = 0;
          this.ekhizmet1SalesPrice = val;
          break;
        case 6:
          this.ekhizmet2SalesPrice = 0;
          this.ekhizmet2SalesPrice = val;
          break;
        case 7:
          this.ekhizmet3SalesPrice = 0;
          this.ekhizmet3SalesPrice = val;
          break;
        case 8:
          this.ekhizmet4SalesPrice = 0;
          this.ekhizmet4SalesPrice = val;
          break;
        case 9:
          this.ekhizmet5SalesPrice = 0;
          this.ekhizmet5SalesPrice = val;
          break;
        case 10:
          this.ekhizmet6SalesPrice = 0;
          this.ekhizmet6SalesPrice = val;
          break;
        case 11:
          this.ekhizmet7SalesPrice = 0;
          this.ekhizmet7SalesPrice = val;
          break;
        default:
          break;
      }
      this.totalSalesPrice =
        Number(this.konsoloslukSalesPrice) +
        Number(this.sigortaSalesPrice) +
        Number(this.hizmetSalesPrice) +
        Number(this.digerSalesPrice) +
        Number(this.ekhizmet1SalesPrice) +
        Number(this.ekhizmet2SalesPrice) +
        Number(this.ekhizmet3SalesPrice) +
        Number(this.ekhizmet4SalesPrice) +
        Number(this.ekhizmet5SalesPrice) +
        Number(this.ekhizmet6SalesPrice) +
        Number(this.ekhizmet7SalesPrice);

        this.profit=this.totalSalesPrice - this.totalCostPrice;
    },
    changeCostPrice(val, tip) {
      
      switch (tip) {
        case 1:
          this.konsoloslukCostPrice = 0;
          this.konsoloslukCostPrice = val;
          break;
        case 2:
          this.sigortaCostPrice = 0;
          this.sigortaCostPrice = val;
          break;
        case 3:
          this.hizmetCostPrice = 0;
          this.hizmetCostPrice = val;
          break;
        case 4:
          this.digerCostPrice = 0;
          this.digerCostPrice = val;
          break;
        case 5:
          this.ekhizmet1CostPrice = 0;
          this.ekhizmet1CostPrice = val;
          break;
        case 6:
          this.ekhizmet2CostPrice = 0;
          this.ekhizmet2CostPrice = val;
          break;
        case 7:
          this.ekhizmet3CostPrice = 0;
          this.ekhizmet3CostPrice = val;
          break;
        case 8:
          this.ekhizmet4CostPrice = 0;
          this.ekhizmet4CostPrice = val;
          break;
        case 9:
          this.ekhizmet5CostPrice = 0;
          this.ekhizmet5CostPrice = val;
          break;
        case 10:
          this.ekhizmet6CostPrice = 0;
          this.ekhizmet6CostPrice = val;
          break;
        case 11:
          this.ekhizmet7CostPrice = 0;
          this.ekhizmet7CostPrice = val;
          break;
        default:
          break;
      }

      this.totalCostPrice =
        Number(this.konsoloslukCostPrice) +
        Number(this.sigortaCostPrice) +
        Number(this.hizmetCostPrice) +
        Number(this.digerCostPrice) +
        Number(this.ekhizmet1CostPrice) +
        Number(this.ekhizmet2CostPrice) +
        Number(this.ekhizmet3CostPrice) +
        Number(this.ekhizmet4CostPrice) +
        Number(this.ekhizmet5CostPrice) +
        Number(this.ekhizmet6CostPrice) +
        Number(this.ekhizmet7CostPrice);

        this.profit=this.totalSalesPrice - this.totalCostPrice;
    },
    vizeKisiAra() {
      this.vizeAdresDialogData.dialogShow = true;
    },
    kisiAra() {
      this.adresDialogData.dialogShow = true;
    },
    TabActive(val) {
      if (val == 1) {
        this.fiyatBilgiTab = true;
      } else if (val == 2) {
        this.odemelerTab = true;
      } else {
        this.active = "0";
      }
    },
    checkNameAndSurname(val) {
      if (val.firstName == null || val.lastName == null || val.lastName == "") {
        var isim = val.adSoyad.trim();
        var isimList = isim.split(/(\s+)/); // adSoyad  ' ' (bosluk) alanına göre split ediliyor.
        // Kullanıcının Adı 1 den fazla mı kontrol'ü yapılıyor.
        if (isimList.length > 3) {
          this.Vize.kisi.firstName = isimList[0] + " " + isimList[2];
          this.Vize.kisi.lastName = isimList[4];
        } else {
          this.Vize.kisi.firstName = isimList[0];
          this.Vize.kisi.lastName = isimList[2];
        }
      }
    },
    getSalesKDV(val, tip) {
      var prm = {
        id: "",
        kod: val,
        aciklama: "",
        tip: tip,
      };
      tool.http_post(this, "SaticiAra", prm).then(
        (response) => {
          if (tip == 14) {
            this.Vize.Sigorta.satis.KDVOran = response.body[0].KDV;
          }
          if (tip == 11) {
            this.Vize.Konsolosluk.satis.KDVOran = response.body[0].KDV;
          }
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    getSaler(tip, val) {
      var prm = {
        id: "",
        kod: val,
        aciklama: "",
        tip: tip,
      };
      tool.http_post(this, "SaticiAra", prm).then(
        (response) => {
          if (prm.tip == 11) {
            //konsolosluk

            this.Vize.Konsolosluk.satici.id = response.body[0].id;
            this.Vize.Konsolosluk.satici.isim = response.body[0].isim;
            this.Vize.Konsolosluk.satici.CariKod = response.body[0].CariKod;
            this.Vize.Konsolosluk.satici.YurtIci_YurtDisi =
              response.body[0].YurtIci_YurtDisi;
          } else if (prm.tip == 14) {
            //sigorta
            this.Vize.Sigorta.satici.id = response.body[0].id;
            this.Vize.Sigorta.satici.isim = response.body[0].isim;
            this.Vize.Sigorta.satici.CariKod = response.body[0].CariKod;
            this.Vize.Sigorta.satici.YurtIci_YurtDisi =
              response.body[0].YurtIci_YurtDisi;
          }
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    vizeSend() {
      this.NameRules = [(v) => !!v || this.$t("Mandatory-Areas")];
      if (this.$refs.formVize.validate()) {
        this.loadingdialog = true;
        if (
          typeof this.$route.query.TakipNo !== "undefined" &&
          this.$route.query.TakipNo
        ) {
          this.loadingmesaj = "Vize Güncelleme ";
        } else {
          this.loadingmesaj = "Vize Kayıt ";
        }
        //Randevu tarih ve Saat birleştiriliyor
        if (
          this.Vize.Konsolosluk.KalemDetay.RandevuZamani != null &&
          this.RandevuZamaniSaat.length > 0
        ) {
          this.Vize.Konsolosluk.KalemDetay.RandevuZamani =
            this.Vize.Konsolosluk.KalemDetay.RandevuZamani.substring(0, 11) +
            "T" +
            this.RandevuZamaniSaat +
            ":00";
        }
        this.Vize.Konsolosluk.donem1 =
          this.Vize.Konsolosluk.KalemDetay.IstenenDonem1;
        this.Vize.Konsolosluk.donem2 =
          this.Vize.Konsolosluk.KalemDetay.IstenenDonem2;

        var params = {
          TakipNo: 0,
          VizeFiyat: this.vizeSatisFiyat,
          Vize: this.Vize,
        };

        tool.http_post(this, "VizeSaveFiyatTaksim", params).then(
          (response) => {
            if (response.body.Status && response.body.Status !== "undefined") {
              if (response.body.data.masrafMerkezi.id == 0) {
                if (response.body.ErrorList.length != 0) {
                  this.text1 = response.body.ErrorList[0];
                  this.snackbar = true;
                  this.loadingdialog = false;
                }
                response.body.data.masrafMerkezi = {
                  id: "",
                  kod: "",
                  isim: "",
                  isimAra: "",
                };
              }
              if (response.body.data.acenteDepartman.id == 0) {
                response.body.data.acenteDepartman = {
                  id: "",
                  kod: null,
                  isim: "",
                  isimAra: "",
                };
              }
              this.dialogFiyatBul = false;
              this.vizeSaticiDialog = false;
              this.Vize = response.body.data;
              //Yolcu Bilgileri Ad Soyad Ayrı yazımı varmı yokmu control ediliyor
              this.checkNameAndSurname(this.Vize.kisi);
              // Kalemler boş ise null olarak doldurmak için kontrol
              this.vizeNullCheck();
              // Kayıtdan sonra güncelleme için kontrol ve yönlendirme
              this.TabActive();
              if (this.Vize.takipNo != null) {
                this.KayitVarmi = true;
                var url =
                  "#/coper/vize/yeni/id?islem=get&TakipNo=" + this.Vize.takipNo;
                window.open(url, "_self");
              }
              //this.odemelerTab = true;
              this.islemTipi = "get";
              this.loadingdialog = false;
              this.dialogPasaportDurum = false;
              this.fiyatBilgiTab = false;
            } else {
              if (response.body.ErrorList != 0) {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingdialog = false;
              }
            }
          },
          (response) => {
            this.text1 = response.body.ExceptionMessage;
            this.snackbar = true;
            this.loadingdialog = false;
          }
        );
      }
    },
    checkBiilInformation(billInformation){
      var result = billInformation.find(x => x.FatTip == 1 || x. FatTip == 3);
      if(result === undefined){
        return true;
      }else{
        return false;
      }
    }
  },
  watch: {
    "Vize.kayitTarihi": function (val) {
      console.log(val);
      console.log(this.Vize.kayitTarihi);
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem1 =
        this.Vize.kayitTarihi;
    },
   
    
    "vizeAdresDialogData.name": function (val) {
      this.Vize.Konsolosluk.KalemDetay.VizeSorumlusu =
        this.vizeAdresDialogData.name;
    },
    "adresDialogData.adres": function (val) {

      this.Vize.kisi.id = val.id;
      this.Vize.kisi.adSoyad = val.adSoyad;
      this.Vize.kisi.gsm = val.gsm;
      this.Vize.kisi.tcKimlikNo = val.tcKimlikNo;
      this.Vize.kisi.firstName = val.firstName;
      this.Vize.kisi.lastName = val.lastName;
      this.Vize.kisi.eMail = val.eMail;
      this.Vize.kisi.telefon1 = val.gsm;
      this.Vize.kisi.cinsiyet = val.Cinsiyet;
      this.Vize.kisi.dogumTarihi = val.DogumTarihi;
      this.Vize.kisi.adres = val.Adres;
      this.Vize.Konsolosluk.KalemDetay.PasaportNo = val.pasaportNo;
      this.Vize.Konsolosluk.KalemDetay.VerildigiYer = val.pasaportVerilisYeri;
      this.Vize.Konsolosluk.KalemDetay.VerilisTarihi = val.pasaportVerilisTarihi;
      this.Vize.Konsolosluk.KalemDetay.BitisTarihi = val.pasaportBitisTarihi;
      this.Vize.kisi.Uyruk = val.ulke;
      
      //this.Vize.kisi = this.adresDialogData.adres;
      this.checkNameAndSurname(this.adresDialogData.adres);
    },
    "Vize.Sigorta.satici.kod": function (val) {
      if (val != null) {
        this.getSaler(14, val);
      } else {
        this.Vize.Sigorta.satici.id = 0;
        this.Vize.Sigorta.satici.isim = "";
        this.Vize.Sigorta.satici.KDV = 0;
        this.Vize.Sigorta.satici.CariKod = "";
        this.Vize.Sigorta.satici.YurtIci_YurtDisi = "";
      }
      this.Vize.Sigorta.satici.kod = val;

      if (this.islemTipi != "get") {
        this.firstSigortaControl = 5;
      }
      if (val != null && val !== "undefined" && this.firstSigortaControl > 1) {
        this.getSalesKDV(val, 14);
      } else {
        this.firstSigortaControl = this.firstSigortaControl + 1;
      }
    },
    "Vize.Konsolosluk.satici.kod": function (val) {
      if (val != null) {
        this.getSaler(11, val);
      } else {
        this.Vize.Konsolosluk.satici.id = 0;
        this.Vize.Konsolosluk.satici.isim = "";
        this.Vize.Konsolosluk.satici.KDV = 0;
        this.Vize.Konsolosluk.satici.CariKod = "";
        this.Vize.Konsolosluk.satici.YurtIci_YurtDisi = "";
      }

      if (this.islemTipi != "get") {
        this.firstVizeControl = 5;
      }

      this.Vize.Konsolosluk.satici.kod = val;
      if (val != null && val !== "undefined" && this.firstVizeControl > 1) {
        this.getSalesKDV(val, 11);
      } else {
        this.firstVizeControl = this.firstVizeControl + 1;
      }
    },
  },
  filters: {
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    priceFormat: function (price) {
      return Number.parseFloat(price).toFixed(2);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
  },
  components: {
    tarihim,
    caricomp,
    konsoloslukara,
    sigortaara,
    vizecesidi,
    genelarama,
    geneltipara,
    masrafmerkezicomp,
    fiyatbilgileri,
    snackbarcomp,
    loadingcomp,
    kisiadresara,
    sirketkisiara,
    saticiortakbilgi,
    yetkidialog,
    iptaldialog,
    odemetab,
    konsoloslukminiara,
    toplukisiekle,
    kisiekle,
    profildialog
  },
};

function beforeMount() {
  this.Vize = Object.assign(this.vizeData, this.Rez);
}

function vizePush() {
  
  this.NameRules = [(v) => !!v || this.$t("Mandatory-Areas")];
  if (this.$refs.formVize.validate()) {
    this.loadingdialog = true;
    if (
      typeof this.$route.query.TakipNo !== "undefined" &&
      this.$route.query.TakipNo
    ) {
      this.loadingmesaj = "Vize Güncelleme ";
    } else {
      this.loadingmesaj = "Vize Kayıt ";
    }
    //Randevu tarih ve Saat birleştiriliyor
    if (
      this.Vize.Konsolosluk.KalemDetay.RandevuZamani != null &&
      this.RandevuZamaniSaat.length > 0
    ) {
      this.Vize.Konsolosluk.KalemDetay.RandevuZamani =
        this.Vize.Konsolosluk.KalemDetay.RandevuZamani.substring(0, 11) +
        "T" +
        this.RandevuZamaniSaat +
        ":00";
    }
    this.Vize.Konsolosluk.donem1 =
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem1;
    this.Vize.Konsolosluk.donem2 =
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem2;

    var params = {
      Vize: this.Vize,
    };

    tool.http_post(this, "VizeSave", params).then(
      (response) => {
        if (response.body.Status && response.body.Status !== "undefined") {
          if (response.body.ErrorList.length != 0) {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
          if (response.body.data.masrafMerkezi.id == 0) {
            response.body.data.masrafMerkezi = {
              id: "",
              kod: "",
              isim: "",
              isimAra: "",
            };
          }
          if (response.body.data.acenteDepartman.id == 0) {
            response.body.data.acenteDepartman = {
              id: "",
              kod: null,
              isim: "",
              isimAra: "",
            };
          }
          this.Vize = response.body.data;
          //Yolcu Bilgileri Ad Soyad Ayrı yazımı varmı yokmu control ediliyor
          this.checkNameAndSurname(this.Vize.kisi);
          // Kalemler boş ise null olarak doldurmak için kontrol
          this.vizeNullCheck();
          // Kayıtdan sonra güncelleme için kontrol ve yönlendirme
          if (this.KayitVarmi==false)
          {
            if (this.Vize.takipNo != null) {
            this.KayitVarmi = true;
            var url ="#/coper/vize/yeni/id?islem=get&TakipNo=" + this.Vize.takipNo;
            window.open(url, "_self");
          }
          //this.odemelerTab = true;
          this.islemTipi = "get";
          this.loadingdialog = false;
          this.dialogPasaportDurum = false;
          var url2 ="#/coper/rezervasyon/rezervasyonlistesi";
            window.open(url2, "_self");
          }
          else
          {
            window.location.reload(true);
          }
         
        } else {
          if (response.body.ErrorList != 0) {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
        }
      },
      (response) => {
        this.text1 = response.body.ExceptionMessage;
        this.snackbar = true;
        this.loadingdialog = false;
      }
    );
  }
  
  
       
}

function vizeMultipleUserPush() {
  this.NameRules = [];
  if (this.$refs.formVize.validate()) {
    this.loadingdialog = true;
    if (
      typeof this.$route.query.TakipNo !== "undefined" &&
      this.$route.query.TakipNo
    ) {
      this.loadingmesaj = "Vize Güncelleme ";
    } else {
      this.loadingmesaj = "Vize Kayıt ";
    }
    //Randevu tarih ve Saat birleştiriliyor
    if (
      this.Vize.Konsolosluk.KalemDetay.RandevuZamani != null &&
      this.RandevuZamaniSaat.length > 0
    ) {
      this.Vize.Konsolosluk.KalemDetay.RandevuZamani =
        this.Vize.Konsolosluk.KalemDetay.RandevuZamani.substring(0, 11) +
        "T" +
        this.RandevuZamaniSaat +
        ":00";
    }
    this.Vize.Konsolosluk.donem1 =
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem1;
    this.Vize.Konsolosluk.donem2 =
      this.Vize.Konsolosluk.KalemDetay.IstenenDonem2;
    var _kisiList = {
      kisiList: this.cokluKisiList,
    };
    Object.assign(this.Vize, _kisiList);
    var params = {
      Vize: this.Vize,
    };

    tool.http_post(this, "VizeSaveCokluKisi", params).then(
      (response) => {
        if (response.body.Status && response.body.Status !== "undefined") {
          if (response.body.ErrorList.length != 0) {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
          this.Vize = response.body.data;
          // Kalemler boş ise null olarak doldurmak için kontrol
          this.vizeNullCheck();

          this.KayitVarmi = true;
          var url = "#/coper/rezervasyon/rezervasyonlistesi";
          window.open(url, "_self");
          this.loadingdialog = false;
          this.dialogPasaportDurum = false;
        } else {
          if (response.body.ErrorList != 0) {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingdialog = false;
          }
        }
      },
      (response) => {
        this.text1 = response.body.ExceptionMessage;
        this.snackbar = true;
        this.loadingdialog = false;
      }
    );
  } else {
    this.text1 = "Zorunlu Alanlari Doldurunuz";
    this.snackbar = true;
  }
}

function vizeNullCheck() {
  //vize kalemindeki faturabilgi fattip liste şeklinde geliyor find ile kontrol et.
  //kalemlerde sadece vize kalemimi baz alınmalı
  //Eğer Diğerleri null ise güncelleme kısmında gözükmeleri için obje çekiliyor
  if (this.Vize.Konsolosluk == null) {
    this.Vize.Konsolosluk = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemKonsolosluk()
    );
  } else {
    if (
      this.Vize.Konsolosluk.faturaBilgileri &&
      this.Vize.Konsolosluk.faturaBilgileri.length
    ) {
      //FatTip 1 alani var ona gore satici degistirme haric acilacak 13397
      var billControl = this.checkBiilInformation(this.Vize.Konsolosluk.faturaBilgileri);
      if(billControl){
        this.faturaValue = true;
      }
      this.konsDisabledValue = true;
        this.gelenFaturaValue = true;

    }
    this.changeSalesPrice(this.Vize.Konsolosluk.satis.NetTutar, 1);
    this.changeCostPrice(this.Vize.Konsolosluk.alis.NetTutar, 1);
  }
  if (this.Vize.Sigorta == null) {
    this.Vize.Sigorta = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemSigorta()
    );
  } else {
    this.changeSalesPrice(this.Vize.Sigorta.satis.NetTutar, 2);
    this.changeCostPrice(this.Vize.Sigorta.alis.NetTutar, 2);
    if (
      this.Vize.Sigorta.faturaBilgileri &&
      this.Vize.Sigorta.faturaBilgileri.length
    ) {

      var billControl = this.checkBiilInformation(this.Vize.Sigorta.faturaBilgileri);
      
      if(billControl){
        this.faturaValue = true;
      }
        this.sigortaDisabledValue = true;
        this.gelenFaturaValue = true;
    }
  }
  if (this.Vize.Hizmet == null) {
    this.Vize.Hizmet = Object.assign({}, vize.KalemBase(), vize.KalemDiger());
  } else {
    this.changeSalesPrice(this.Vize.Hizmet.satis.NetTutar, 3);
    this.changeCostPrice(this.Vize.Hizmet.alis.NetTutar, 3);
    if (
      this.Vize.Hizmet.faturaBilgileri &&
      this.Vize.Hizmet.faturaBilgileri.length
    ) {

      var billControl = this.checkBiilInformation(this.Vize.Hizmet.faturaBilgileri);
      
      if(billControl){
        this.faturaValue = true;
      }

        this.gelenFaturaValue = true;
    }
  }
  if (this.Vize.Diger == null) {
    this.Vize.Diger = Object.assign({}, vize.KalemBase(), vize.KalemDiger());
  } else {
    this.changeSalesPrice(this.Vize.Diger.satis.NetTutar, 4);
    this.changeCostPrice(this.Vize.Diger.alis.NetTutar, 4);
    if (
      this.Vize.Diger.faturaBilgileri &&
      this.Vize.Diger.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;
        var billControl = this.checkBiilInformation(this.Vize.Diger.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
  if (this.Vize.EkHizmet1 == null) {
    this.Vize.EkHizmet1 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet1.satis.NetTutar, 5);
    this.changeCostPrice(this.Vize.EkHizmet1.alis.NetTutar, 5);
    if (
      this.Vize.EkHizmet1.faturaBilgileri &&
      this.Vize.EkHizmet1.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;
        var billControl = this.checkBiilInformation(this.Vize.EkHizmet1.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
  if (this.Vize.EkHizmet2 == null) {
    this.Vize.EkHizmet2 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet2.satis.NetTutar, 6);
    this.changeCostPrice(this.Vize.EkHizmet2.alis.NetTutar, 6);
    if (
      this.Vize.EkHizmet2.faturaBilgileri &&
      this.Vize.EkHizmet2.faturaBilgileri.length
    ) {
      var billControl = this.checkBiilInformation(this.Vize.EkHizmet2.faturaBilgileri);
      
      if(billControl){
        this.faturaValue = true;
      }

        this.gelenFaturaValue = true;
    }
  }
  if (this.Vize.EkHizmet3 == null) {
    this.Vize.EkHizmet3 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet3.satis.NetTutar, 7);
    this.changeCostPrice(this.Vize.EkHizmet3.alis.NetTutar, 7);
    if (
      this.Vize.EkHizmet3.faturaBilgileri &&
      this.Vize.EkHizmet3.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;

        var billControl = this.checkBiilInformation(this.Vize.EkHizmet3.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
  if (this.Vize.EkHizmet4 == null) {
    this.Vize.EkHizmet4 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet4.satis.NetTutar, 8);
    this.changeCostPrice(this.Vize.EkHizmet4.alis.NetTutar, 8);
    if (
      this.Vize.EkHizmet4.faturaBilgileri &&
      this.Vize.EkHizmet4.faturaBilgileri.length
    ) {

      var billControl = this.checkBiilInformation(this.Vize.EkHizmet4.faturaBilgileri);
      
      if(billControl){
        this.faturaValue = true;
      }

        this.gelenFaturaValue = true;
    }
  }
  if (this.Vize.EkHizmet5 == null) {
    this.Vize.EkHizmet5 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet5.satis.NetTutar, 9);
    this.changeCostPrice(this.Vize.EkHizmet5.alis.NetTutar, 9);
    if (
      this.Vize.EkHizmet5.faturaBilgileri &&
      this.Vize.EkHizmet5.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;

        var billControl = this.checkBiilInformation(this.Vize.EkHizmet5.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
  if (this.Vize.EkHizmet6 == null) {
    this.Vize.EkHizmet6 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet6.satis.NetTutar, 10);
    this.changeCostPrice(this.Vize.EkHizmet6.alis.NetTutar, 10);
    if (
      this.Vize.EkHizmet6.faturaBilgileri &&
      this.Vize.EkHizmet6.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;
        var billControl = this.checkBiilInformation(this.Vize.EkHizmet6.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
  if (this.Vize.EkHizmet7 == null) {
    this.Vize.EkHizmet7 = Object.assign(
      {},
      vize.KalemBase(),
      vize.KalemDiger()
    );
  } else {
    this.changeSalesPrice(this.Vize.EkHizmet7.satis.NetTutar, 11);
    this.changeCostPrice(this.Vize.EkHizmet7.alis.NetTutar, 11);
    if (
      this.Vize.EkHizmet7.faturaBilgileri &&
      this.Vize.EkHizmet7.faturaBilgileri.length
    ) {
        this.gelenFaturaValue = true;
        var billControl = this.checkBiilInformation(this.Vize.EkHizmet7.faturaBilgileri);
      
        if(billControl){
          this.faturaValue = true;
        }
    }
  }
}

function kurCek() {
  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    CompanyCode: credentials.SirketKodu,
  };

  this.$http
    .post(auth.API_URL + "api/currency/List", params, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.doviztipi = response.body;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-Döviz";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-Döviz";
          this.snackbar = true;
        }
      }
    );
}
</script>